import React from 'react';
import AccordionItem from './AccordionItem';
import navData from '../navData';

const Accordion = () => {
    return (
        <div className="nav_accordion-wrapper">
            <ul className="nav_accordion-list">
                {navData.map((accordionData) => {
                    return (
                        <li className="nav_accordion-list__item" key={accordionData.title}>
                            <AccordionItem data={accordionData} key={accordionData.title} />
                        </li>
                    );
                })}
            </ul>
        </div>

    );
};

export default Accordion;
